import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function OwnerFinderUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-6097">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6098">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-6099">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-6100">
            Local business owner finder for{' '}
            <span className="text-blue-600" data-id="element-6101">every team</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-6102">
            From sales to partnerships, see how teams use our local business
            owner finder to connect with decision-makers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6103">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-6104">
            <div data-id="element-6105">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-6106">
                Sales prospecting
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-6107">
                Find local business owners in your target market and reach them
                with verified emails and direct phones.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-6108">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-6109" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-6110">
                The local business owner finder cut our prospecting time by 80%.
                We went from guessing to connecting.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-6111">
                — Marcus D., Sales manager
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-6112">
            <div data-id="element-6113">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-6114">
                Partnership outreach
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-6115">
                Identify local business owners for co-marketing, distribution,
                or vendor partnerships.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-6116">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-6117" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-6118">
                We found 200 local business owners in our target area in under
                an hour. Game changer for partnerships.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-6119">
                — Priya S., BD lead
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-6120">
            <div data-id="element-6121">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-6122">
                Local services sales
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-6123">
                Reach restaurant owners, clinic owners, and retail store owners
                selling SaaS, payments, or insurance.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-6124">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-6125" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-6126">
                Finding business owner contacts used to take days. Now our reps
                have verified owner emails in seconds.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-6127">
                — Tom H., VP of sales
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}